import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {isNullOrUndefined} from '../../../../util/utils';
import {useAresUrlParameters, useSelectedStEntityId} from '../../../../util/Ares/customHooks';
import AssociatedRiskList from './AssociatedRiskList';
import {getAllAssociatedRisksSummary} from '../../../../actions/AssessRiskSummary/assessRiskSummaryActions';
import {getAccounts} from '../../../../actions/Account/accountactions';
import {RiskFactorsValidExpands, getRiskFactors} from '../../../../actions/RiskFactor/riskfactoractions';
import {getTaskDocumentByDocumentId} from '../../../../selectors/Ares/selectors';
import RiskFactorsSummaryList from '../../CanvasForm/Bodies/Common/RiskFactorsSummaryList';

const AssociatedRisk = (props) => {
	const dispatch = useDispatch();

	// Redux states.
	const engagementId = useSelector((state) => state.engagementId);
	const assessRiskSummary = useSelector((state) => state.assessRiskSummary);
	const riskFactors = useSelector((store) => store.riskFactors);
	const {documentId} = useAresUrlParameters();
	const document = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));
	const [selectedStEntityId] = useSelectedStEntityId();

	const riskFactorsNotaROMM =
		riskFactors?.length > 0
			? riskFactors?.filter((rf) => (rf.riskTypeId === null || rf.riskTypeId === 0) && rf.isNotMaterial)
			: [];

	// Local states.
	const [risksSummary, setRisksSummary] = useState([]);

	useEffect(() => {
		const fetchRisksSummary = async () => {
			dispatch(getAllAssociatedRisksSummary(engagementId));
			dispatch(getAccounts(engagementId, {includeAssertions: true}));
		};
		fetchRisksSummary().then((r) => r);
		const getAllRiskFactors = async () => {
			dispatch(
				getRiskFactors(engagementId, {
					expand: RiskFactorsValidExpands.formHeaders,
					filterMultiEntityIds: selectedStEntityId
						? selectedStEntityId
						: !isNullOrUndefined(document?.stEntityId)
						? document.stEntityId
						: undefined
				})
			);
		};
		getAllRiskFactors().then((r) => r);
	}, [engagementId, selectedStEntityId]);

	useEffect(() => {
		if (Object.keys(assessRiskSummary).length > 0) {
			setRisksSummary([...assessRiskSummary.data]);
		}
	}, [assessRiskSummary]);

	return (
		<StyledAssociateRiskAccordion className={props.className}>
			<div className="associaterisk-accordion">
				<AssociatedRiskList associatedRisksSummary={risksSummary} />
				<RiskFactorsSummaryList riskFactorsList={riskFactorsNotaROMM} isThisNotaROMM />
			</div>
		</StyledAssociateRiskAccordion>
	);
};

export default AssociatedRisk;

const StyledAssociateRiskAccordion = styled.section`
	padding: var(--px-30) var(--px-155);
	margin-bottom: var(--px-30);
	cursor: default;
	.associaterisk-accordion {
		.motif-accordion-icons svg {
			fill: var(--blue-600);
		}
		span {
			display: block;
		}
		span.motif-icon {
			display: inline-block;
		}

		.no-risk {
			color: var(--neutrals-700);
			font-size: var(--px-12);
			font-weight: normal;
			padding-bottom: var(--px-8);
		}
		.risk-type {
			font-size: var(--px-14);
			font-weight: bold;
			padding-bottom: var(--px-8);
		}
		ul li ul .no-risk {
			margin-bottom: var(--px-10);
		}
		ul li:last-child ul .no-risk {
			margin-bottom: var(--px-15);
		}
		.risktype-list {
			padding-left: var(--px-15);
			li {
				margin-bottom: var(--px-15);
			}
			.no-risk {
				color: var(--neutrals-700);
				font-size: var(--px-12);
				font-weight: normal;
				padding-bottom: var(--px-8);
			}
			.risk-name {
				font-size: var(--px-12);
				font-weight: normal;
				padding-bottom: var(--px-5);
			}
			.accountassertion-label {
				font-size: var(--px-12);
				font-weight: normal;
				padding-left: var(--px-15);
				padding-bottom: var(--px-5);
			}
			.noacc-linked {
				padding-left: var(--px-30);
				font-size: var(--px-12);
				font-weight: 300;
				color: var(--neutrals-700);
			}
			.related-accountassertion {
				padding-left: var(--px-15);
				padding-bottom: var(--px-10);
				.no-relatedaccounts {
					font-size: var(--px-12);
					font-weight: 300;
					padding-left: 0;
					margin-left: calc(var(--px-15) * -1);
					color: var(--neutrals-700);
				}
				.relatedaccounts-name {
					display: inline-block;
					max-width: 20%;
					padding-left: var(--px-15);
					font-size: var(--px-12);
					font-weight: normal;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					vertical-align: middle;
					.motif-icon {
						width: var(--px-16);
						height: var(--px-16);
						margin-right: var(--px-5);
						color: var(--green-500);
						svg {
							cursor: default;
							vertical-align: middle;
							margin-top: calc(var(--px-2) * -1);
						}
					}
				}
				.account-name {
					display: inline-block;
					max-width: 29%;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					font-size: var(--px-12);
					font-weight: normal;
					margin-left: var(--px-3);
					vertical-align: middle;
				}
				.statement-type {
					display: inline-block;
					max-width: 20%;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					font-size: var(--px-12);
					font-weight: normal;
					color: var(--neutrals-700);
					padding-left: var(--px-3);
					vertical-align: middle;
				}
				.assertions-container {
					display: inline-block;
					max-width: 29%;
					margin-left: var(--px-10);
					vertical-align: middle;
					* > span {
						display: inline;
					}
					li {
						margin-bottom: 0 !important;
						display: inline-block;
						border: none;
						min-width: var(--px-50);
						margin-right: var(--px-3);
						.AssertionBadge {
							padding: 0 !important;
						}
					}
					.sup-thunder {
						display: none !important;
					}
					.assertion {
						padding: var(--px-2) var(--px-4) !important;
						min-width: var(--px-42);
					}
				}
			}
		}
	}
`;
